import {SerializedStyles} from '@emotion/react';
import {css, Typography, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
import {useIntl} from 'react-intl';
import {getIconComponentByName} from 'src/js/common/icons/icon_helpers';
import {GetStylesFunction} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';
import {DlMuiDynamicIcon} from './DlMuiDynamicIcon';

interface OwnProps {
  message: string;
  iconName?: string;
  inputCss?: SerializedStyles;
  isHaidi?: boolean;
}

type Props = OwnProps;

export const NoDataMessageWithIcon: React.FC<Props> = (props) => {
  const {message, iconName = 'infoIcon', inputCss, isHaidi = false, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss, isHaidi}});
  const intl = useIntl();

  const translatedMessage = message && intl && TranslateUtils.translate(message, intl);

  let RenderedIconComponent;

  if (iconName) {
    RenderedIconComponent = getIconComponentByName(iconName);
  }

  return (
    <div {...restProps} css={styles.wrapper}>
      {RenderedIconComponent ? (
        isHaidi ? (
          <DlMuiDynamicIcon iconName='warning' useFixedViewBox={12} svgIconStyle={{width: '12px', height: '12px'}} noButtonStyles />
        ) : (
          <SvgIcon component={RenderedIconComponent} inheritViewBox css={styles.icon} />
        )
      ) : null}
      {translatedMessage && intl ? (
        <Typography css={styles.label} variant={'value'}>
          {TranslateUtils.translate(translatedMessage, intl)}
        </Typography>
      ) : null}
    </div>
  );
};

NoDataMessageWithIcon.displayName = 'NoDataMessageWithIcon';

const getStyles: GetStylesFunction = (options) => {
  const isHaidi = options?.params?.isHaidi;
  return {
    wrapper: css(
      {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isHaidi ? `${options?.theme?.palette.custom.haidiCoolGray['50']}` : '#f5f5f5',
        padding: isHaidi ? `${options?.theme?.spacing(4)}` : `${options?.theme?.spacing(0, 6)}`,
        borderRadius: `${options?.theme?.spacing(2)}`,
        marginTop: isHaidi ? `${options?.theme?.spacing(1.25)}` : 0,
        height: isHaidi ? `${options?.theme?.spacing(11)}` : `${options?.theme?.spacing(12.5)}`,
        width: '100%',
      },
      options?.params?.inputCss
    ),
    icon: css({
      color: `${options?.theme?.palette.common.black}`,
      width: '16px',
      height: '16px',
      marginRight: `${options?.theme?.spacing(2)}`,
    }),
    label: css({
      color: isHaidi ? `${options?.theme?.palette.custom.haidiCoolGray['500']}` : `${options?.theme?.palette.custom.coolGray['900']}`,
      fontSize: isHaidi ? '12px' : '14px',
    }),
  };
};
